export type AiConfig = {
  name: string;
  auth_groups: string[];
  enabled: boolean;
  data: {
    key: string;
    type: string;
  };
};

export const aiConfigDefaultValues = {
  name: "",
  auth_groups: [],
  enabled: true,
  data: {
    key: "",
    type: "",
  },
}
